import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

export enum EVENT_TYPE {
	OPERATIONAL = 'operational',
	SCREEN = 'screen',
	TRACK = 'track',
	UI = 'ui',
}

export type AccountSetupAnalyticsEventPayload = {
	action?: string;
	actionSubject?: string;
	attributes?: Record<string, any>;
	name?: string; //  for screen events
	source?: string;
} & AnalyticsEventPayload;

export type FireAnalyticsEventFn = (payload: AccountSetupAnalyticsEventPayload) => void;

export type FireAnalyticsEvent = {
	fireOperationalAnalyticEvent: FireAnalyticsEventFn;
	fireScreenAnalyticEvent: FireAnalyticsEventFn;
	fireTrackAnalyticEvent: FireAnalyticsEventFn;
	fireUIAnalyticEvent: FireAnalyticsEventFn;
};
